module.exports = __webpack_public_path__ + "img/budgets-background.7de240ba.svg";